import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.replace";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.loadSpecification ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSpecification,
      expression: "showSpecification"
    }],
    staticClass: "Layer-FullScreen component-select-standard",
    on: {
      "click": _vm.slideDownSpecification
    }
  }, [_c('div', {
    staticClass: "main-bottom",
    class: {
      'slide-down': _vm.specificationSlideDown,
      'is-calendar-mode': _vm.isCalendarMode
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "specification-top"
  }, [_c('div', {
    staticClass: "cover-pic"
  }, [_c('img', {
    class: {
      'is-special': _vm.isSpecialPage || _vm.type == 2
    },
    attrs: {
      "src": _vm._f("filterImgLink")(_vm.specDetail.coverPic, _vm.isSpecialPage || _vm.type == 2)
    }
  })]), _c('div', {
    staticClass: "txt"
  }, [!_vm.orderNo ? _c('p', {
    staticClass: "txt-price"
  }, [_c('span', {
    staticClass: "cel-1"
  }, [_c('i', [_vm._v("￥")]), _vm._v(_vm._s(_vm.getPayMoney)), !_vm.promoter.tempSellComm ? _c('span', {
    staticClass: "start"
  }, [_vm._v("起")]) : _vm._e(), _c('span', {
    staticClass: "saving-money"
  }, [_vm.promoter.tempSellComm ? _c('span', [_vm._v("省")]) : _vm._e(), _vm._v(_vm._s(_vm._f("filterCommKeepOne")(_vm.promoter.tempSellComm)))])]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isAPP && !_vm.isReviewing && _vm.specIdKey && _vm.promoter.isShare && _vm.getIsShow(_vm.promoter.tempSellComm + _vm.promoter.tempAppSellComm),
      expression: "isAPP&&!isReviewing&&specIdKey&&promoter.isShare&&getIsShow(promoter.tempSellComm+promoter.tempAppSellComm)"
    }],
    staticClass: "cel-2"
  }, [_c('i', [_vm._v("省")]), _vm._v(_vm._s(_vm.isAPP ? _vm.promoter.tempAppSellComm : _vm.promoter.tempSellComm))])]) : _vm._e(), _c('p', {
    staticClass: "txt-p"
  }, [_vm._v(_vm._s(_vm.standardTxt))])]), _c('i', {
    staticClass: "btn-close",
    on: {
      "click": function click($event) {
        return _vm.slideDownSpecification();
      }
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticClass: "specification-commission"
  }, [_c('div', {
    staticClass: "commission-content"
  }, [_c('div', {
    staticClass: "reward-money"
  }, [_vm.isAPP ? _c('p', [_vm._v("推广奖励" + _vm._s(_vm._f("filterCommKeepOne")(_vm.promoter.tempAppSellComm)))]) : _c('p', [_vm._v("奖励" + _vm._s(_vm._f("filterCommKeepOne")(_vm.promoter.tempSellComm)))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.promoter.selfBuyRate != 1 && _vm.getIsShow(_vm.promoter.tempSellComm + _vm.promoter.tempAppSellComm),
      expression: "promoter.selfBuyRate!=1&&getIsShow(promoter.tempSellComm+promoter.tempAppSellComm)"
    }],
    staticClass: "reward-tips"
  }, [_vm._v("新用户自购前两笔可获部分推广奖励，第三笔开始可以获得全额推广奖励")])])]), _c('div', {
    staticClass: "specification-main"
  }, [_vm.groupBuySteps && _vm.groupBuySteps.length > 0 && !_vm.groupBuyJoin ? _c('div', {
    staticClass: "project-list"
  }, [_c('p', {
    staticClass: "txt-h"
  }, [_vm._v("拼团人数")]), _c('p', {
    staticClass: "txt-p"
  }, _vm._l(_vm.groupBuySteps, function (step, index) {
    return _c('span', {
      key: "groupbuy".concat(index),
      class: {
        'selected': _vm.activeGroupBuyIndex === index
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.selectGroupBuy(index);
        }
      }
    }, [_vm._v(_vm._s(step.memberLimit) + "人团")]);
  }), 0)]) : _vm._e(), _vm.isShowTicket && _vm.useDate.length ? _c('div', {
    staticClass: "project-list"
  }, [_c('p', {
    staticClass: "txt-h"
  }, [_vm._v("时间")]), !_vm.isCalendarMode ? _c('p', {
    staticClass: "txt-p"
  }, _vm._l(_vm.useDate, function (day) {
    return typeof day.sellDate == 'string' ? _c('span', {
      key: day.sellDate,
      class: {
        'selected': day.sellDate == _vm.selectDate.sellDate,
        'disabled': day.isBook != 1 || day.stockNum == 0 || _vm.orderNo
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.selectDay(day);
        }
      }
    }, [_vm._v(_vm._s(day.sellDate.replace(/-/g, ".")) + " " + _vm._s(day.dateStr))]) : _vm._e();
  }), 0) : _vm._e(), _vm.isCalendarMode ? _c('div', {
    staticClass: "standard-calendar"
  }, [_c('div', {
    staticClass: "calendar-month"
  }, _vm._l(_vm.monthList, function (month) {
    return _c('span', {
      key: month.month,
      class: {
        'selected': month.selected
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.selectMonth(month);
        }
      }
    }, [_vm._v(_vm._s(month.month) + "月")]);
  }), 0), _vm._m(0), _vm.dayList.length ? _c('div', {
    staticClass: "day-list"
  }, [_vm._l(_vm.getBlankSpaceNum(_vm.dayList[0].sellDate), function (spaceNum) {
    return _c('div', {
      key: spaceNum
    });
  }), _vm._l(_vm.dayList, function (day, index) {
    return _c('div', {
      key: day.sellDate,
      staticClass: "day"
    }, [_c('div', {
      class: {
        'selected': day.sellDate == _vm.selectDate.sellDate,
        'disabled': day.isBook != 1 || day.stockNum == 0 || _vm.orderNo
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.selectDay(day);
        }
      }
    }, [_c('p', {
      staticClass: "row-1"
    }, [_vm._v(_vm._s(index + 1))]), day.stockNum == 0 ? _c('p', {
      staticClass: "row-2"
    }, [_vm._v("售罄")]) : _vm._e()])]);
  })], 2) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._l(_vm.standardList, function (project) {
    return _c('div', {
      key: project.typeName,
      staticClass: "project-list"
    }, [_c('p', {
      staticClass: "txt-h"
    }, [_vm._v(_vm._s(project.typeName))]), _c('p', {
      staticClass: "txt-p",
      class: {
        'is-multiple': _vm.isMultipleDetails
      }
    }, _vm._l(project.standard, function (specification) {
      return _c('span', {
        key: specification.name,
        class: {
          'selected': specification.selected,
          'disabled': _vm.orderNo || specification.disabled
        },
        on: {
          "click": function click($event) {
            return _vm.selectedSpecification(project, project.standard, project.typeName, specification);
          }
        }
      }, [_vm._v("\r\n                            " + _vm._s(specification.name) + "\r\n                            "), _vm.isMultipleDetails && _vm.priceAndStockNum[specification.id] && typeof _vm.priceAndStockNum[specification.id].price == 'number' ? _c('i', [_vm._v("￥" + _vm._s(_vm.priceAndStockNum[specification.id].price.toFixed(2)))]) : _vm._e()]);
    }), 0)]);
  }), _vm.isShowTicket && _vm.seatingMap ? _c('div', {
    staticClass: "seating-map",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.openSeatingMap.apply(null, arguments);
      }
    }
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/seating_plan_icon.png"
    }
  }), _c('span', [_vm._v("座位图")])], 1) : _vm._e(), _c('div', {
    staticClass: "buy-num"
  }, [_c('div', {
    staticClass: "cel-1",
    class: {
      'vertical-initial': _vm.specDetail.restrictionDetails
    }
  }, [_c('p', {
    staticClass: "row-1"
  }, [_vm._v("购买数量")]), _vm.specDetail.restrictionDetails ? _c('div', {
    staticClass: "row-2"
  }, [_vm.specDetail.restrictionDetails.weChat ? _c('p', [_vm._v("每个微信号" + _vm._s(_vm.specDetail.restrictionDetails.weChat.day ? _vm.specDetail.restrictionDetails.weChat.day + "天内" : "") + "限购" + _vm._s(_vm.specDetail.restrictionDetails.weChat.limit + _vm.specDetail.baseValueUnit))]) : _vm._e(), _vm.specDetail.restrictionDetails.phone ? _c('p', [_vm._v("每个联系人手机号" + _vm._s(_vm.specDetail.restrictionDetails.phone.day ? _vm.specDetail.restrictionDetails.phone.day + "天内" : "") + "限购" + _vm._s(_vm.specDetail.restrictionDetails.phone.limit + _vm.specDetail.baseValueUnit))]) : _vm._e(), _vm.specDetail.restrictionDetails.idCard ? _c('p', [_vm._v("每个证件号码" + _vm._s(_vm.specDetail.restrictionDetails.idCard.day ? _vm.specDetail.restrictionDetails.idCard.day + "天内" : "") + "限购" + _vm._s(_vm.specDetail.restrictionDetails.idCard.limit + _vm.specDetail.baseValueUnit))]) : _vm._e()]) : _vm._e()]), _c('div', {
    staticClass: "cel-2"
  }, [_c('i', {
    staticClass: "less",
    class: {
      'disabled': _vm.buyNum <= 1 || _vm.orderNo || (_vm.isShowTicket || _vm.isMultipleDetails) && _vm.buyNum <= _vm.specDetail.minNum
    },
    on: {
      "click": function click($event) {
        return _vm.changeBuyNum('less');
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.buyNum))]), _c('i', {
    staticClass: "add",
    class: {
      'disabled': _vm.buyNum >= _vm.maxBuyNum || _vm.orderNo
    },
    on: {
      "click": function click($event) {
        return _vm.changeBuyNum('add');
      }
    }
  })])])], 2), _vm.type == 2 ? _c('div', {
    staticClass: "btn-confirm",
    class: {
      'is-activity': _vm.item.isActive,
      'disabled': _vm.specDetail.statusIs != 1 || !_vm.specDetail.specMaxNum
    },
    on: {
      "click": _vm.clickBottomBtn
    }
  }, [_vm._v(_vm._s(_vm.btnText))]) : !_vm.orderNo ? _c('div', {
    staticClass: "specification-foot"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('p', {
    staticClass: "selling-price"
  }, [_c('i', [_vm._v("￥")]), _vm._v(_vm._s(_vm.getTotalPayMoney)), !_vm.promoter.tempSellComm ? _c('span', {
    staticClass: "start"
  }, [_vm._v("起")]) : _vm._e(), _c('span', {
    staticClass: "saving-money"
  }, [_vm.promoter.tempSellComm ? _c('span', [_vm._v("省")]) : _vm._e(), _vm._v(_vm._s(_vm._f("filterCommKeepOne")(_vm.promoter.tempSellComm)))])]), !_vm.promoter.isPromoter ? _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.getRetailPrice > _vm.getTotalPayMoney,
      expression: "getRetailPrice>getTotalPayMoney"
    }],
    staticClass: "original-price"
  }, [_vm._v("门市价:￥" + _vm._s(_vm.getRetailPrice))]) : _vm._e()]), _c('span', {
    staticClass: "btn-buy",
    class: {
      'disabled': !_vm.isOnline || _vm.orderNo,
      'cancel-reminder': !_vm.isNeedAddCart && _vm.buyBtnTxt == '取消提醒'
    },
    on: {
      "click": function click($event) {
        _vm.isNeedAddCart ? _vm.addToShoppingCart() : _vm.btnCallback(_vm.groupBuySteps[_vm.activeGroupBuyIndex], _vm.groupBuyDiscount);
      }
    }
  }, [_vm._v(_vm._s(_vm.isNeedAddCart ? "确定" : _vm.buyBtnTxt))])]) : _vm._e()])]) : _vm._e(), _c('ycf-download-tips', {
    attrs: {
      "visible": _vm.showDownloadTips,
      "type": "3"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.showDownloadTips = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "calendar-week"
  }, [_c('span', [_vm._v("日")]), _c('span', [_vm._v("一")]), _c('span', [_vm._v("二")]), _c('span', [_vm._v("三")]), _c('span', [_vm._v("四")]), _c('span', [_vm._v("五")]), _c('span', [_vm._v("六")])]);
}];
export { render, staticRenderFns };